module.exports = __webpack_public_path__ + "img/index_message.f88c8784.png";